import { access_control_list_tab, managers_tab } from '../../../../../../views/team/managers';

export default {
  tabs: {
    [managers_tab]: 'Managers',
    [access_control_list_tab]: 'Zugangskontrolle',
  },
};
